(() => {
  const params = new URLSearchParams(window.location.search);
  const rawColor = params.get("color");
  if (!rawColor) return;

  const normalize = (str) =>
    String(str || "")
      .trim()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, "-");

  const targetColor = normalize(rawColor);

  let attempts = 0;
  const interval = setInterval(() => {
    attempts++;

    const swatches = Array.from(
      document.querySelectorAll(".color-item.swatch[data-color]")
    );

    if (!swatches.length) {
      if (attempts >= 30) clearInterval(interval);
      return;
    }

    const match = swatches.find(
      (el) => normalize(el.dataset.color) === targetColor
    );

    if (!match) {
      if (attempts >= 30) clearInterval(interval);
      return;
    }

    // Estado visual
    swatches.forEach((el) => el.classList.remove("color-selected"));
    match.classList.add("color-selected");

    // Activar selección real
    const label = match.querySelector("label.swatch-label");
    const radio = match.querySelector('input[type="radio"]');

    if (label) {
      label.click();
    } else if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event("change", { bubbles: true }));
    }

    clearInterval(interval);
  }, 120);
})();